import type { ReactNode } from 'react';

export const symbol_local_pharmacy: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M183-120q-31.15 0-48.57-25Q117-170 127-199l80-236-80-236q-10-29 7.43-54 17.42-25 48.57-25h464l49-135q5-14 19.5-20.5t28.5-1q14 5.5 20 19t1 27.5l-40 110h52q31.15 0 48.57 25.5Q843-699 833-670l-81 235 81 235q10 29-7.43 54.5Q808.15-120 777-120H183Zm269-161h60v-124h124v-60H512v-124h-60v124H328v60h124v124ZM182-180h596l-88-255 88-255H182l88 255-88 255Zm298-255Z"
		/>
	</svg>
);
